import { render, staticRenderFns } from "./marginApplication.vue?vue&type=template&id=01e8b7c8&"
import script from "./marginApplication.vue?vue&type=script&lang=js&"
export * from "./marginApplication.vue?vue&type=script&lang=js&"
import style0 from "./marginApplication.vue?vue&type=style&index=0&id=01e8b7c8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports